/* Hi page: tap Bob's head for fireworks (same effect as the Contact page). The "Tap me!" bubble leaves after the first tap. */
(function () {
  var bob = document.getElementById('hiBob');
  if (!bob) return;
  var tap = document.getElementById('hiTap');
  var colors = ['#38b6ff', '#ff3131', '#cb6ce6', '#ff66c4', '#ffd84d', '#ffffff'];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var layer = null;

  function getLayer() {
    if (layer) return layer;
    layer = document.createElement('div');
    layer.setAttribute('aria-hidden', 'true');
    layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;overflow:hidden;z-index:9999';
    document.body.appendChild(layer);
    return layer;
  }

  function burst(x, y, count, spread) {
    var host = getLayer();
    for (var i = 0; i < count; i++) {
      var p = document.createElement('i');
      var size = 6 + Math.random() * 8;
      var round = Math.random() < 0.5;
      p.style.cssText = 'position:absolute;left:' + x + 'px;top:' + y + 'px;width:' + size + 'px;height:' + (round ? size : size * 0.6) + 'px;border-radius:' + (round ? '50%' : '2px') + ';background:' + colors[i % colors.length] + ';will-change:transform,opacity';
      host.appendChild(p);
      var angle = Math.random() * Math.PI * 2;
      var speed = spread * (0.4 + Math.random() * 0.5);
      var dx = Math.cos(angle) * speed;
      var dy = Math.sin(angle) * speed;
      var rot = (Math.random() * 720 - 360) | 0;
      var life = 2600 + Math.random() * 1400;
      p.animate([
        { transform: 'translate(-50%,-50%) translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: 'translate(-50%,-50%) translate(' + dx * 0.75 + 'px,' + (dy * 0.75 - 50) + 'px) rotate(' + rot * 0.5 + 'deg)', opacity: 1, offset: 0.4 },
        { transform: 'translate(-50%,-50%) translate(' + dx * 0.95 + 'px,' + (dy + 90) + 'px) rotate(' + rot * 0.8 + 'deg)', opacity: .9, offset: 0.72 },
        { transform: 'translate(-50%,-50%) translate(' + dx + 'px,' + (dy + 300) + 'px) rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: life, easing: 'cubic-bezier(.2,.6,.4,1)', fill: 'forwards' }).onfinish = (function (el) { return function () { el.remove(); }; })(p);
    }
  }

  function fireworks() {
    var r = bob.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height * 0.45;
    burst(cx, cy, 70, 260);
    setTimeout(function () { burst(cx - r.width * 0.9, cy - 30, 45, 200); burst(cx + r.width * 0.9, cy - 30, 45, 200); }, 350);
    setTimeout(function () { burst(cx, cy - 90, 60, 240); }, 750);
  }

  var busy = false;
  bob.addEventListener('click', function () {
    if (tap) { tap.classList.add('gone'); }
    if (busy) return;
    busy = true;
    bob.classList.remove('is-happy');
    void bob.offsetWidth;
    bob.classList.add('is-happy');
    if (!reduce) fireworks();
    setTimeout(function () { busy = false; bob.classList.remove('is-happy'); }, 900);
  });
})();
